/* eslint-disable  @typescript-eslint/no-non-null-asserted-optional-chain */
import { useContext, useState } from 'react'
import { ScrollView, Image, KeyboardAvoidingView, Platform, Text } from 'react-native'
import { globalStyle } from '../../../../../theme/global'
import { TemplatePage } from '../../../../../components/TemplatePage'
import { NecropsyContext } from '../../../../../context/Necropsy/Provider'
import { Separator } from '../../../../../components/Separator'
import { PhotoCard } from '../../../components/PhotoCard'
import { useForm } from '../../../../../hooks/useForm'
import { AlertMessage } from '../../../../../components/AlertMessage'
import { useNavigation } from '@react-navigation/native'
import { NecropsyRoutes } from '../../../../../navigator/types'
import { StackNavigationProp } from '@react-navigation/stack'
import { FormHeader } from '../../../components/FormHeader'
import { textColor } from '../../../../../theme/colors'
import { Comments } from './Components/Comments'
import { ActionsButtons } from './Components/ActionsButtons'
import { AditionalPhoto } from './Components/AditionalPhoto'
import { useMoveScroll } from '../../../../../hooks/useMoveScroll'
import { useKeyboardVisibility } from '../../../../../hooks/useKeyboardVisibility'
import { useTranslation } from 'react-i18next'

interface NavigationParams extends StackNavigationProp<NecropsyRoutes, 'Summary'> {}

interface ReviewPhoto {
  show: boolean
  uri: string
  action: () => void
}

export const Summary = () => {
  const {
    form: { externalPhoto, internalPhoto, gillPhoto, additionalPhotos },
    removeAditionalPhoto,

    handleFinalForm,
  } = useContext(NecropsyContext)
  const { t } = useTranslation()
  const navigation = useNavigation<NavigationParams>()

  const { handleKeyboardPadding } = useKeyboardVisibility()
  const { scrollViewRef } = useMoveScroll({
    handleKeyboardPadding,
  })

  const [isCameraOpen, setIsCameraOpen] = useState(false)
  const [showReviewPhoto, setShowReviewPhoto] = useState<ReviewPhoto>({
    show: false,
    uri: '',
    action() {},
  })
  const [maxLengthText, setmaxLengthText] = useState({ show: false })
  const { onChangeValues, values } = useForm({
    comments: '',
  })

  const handleSaveData = () => {
    handleFinalForm(values.comments)
    navigation.replace('Success')
  }

  if (isCameraOpen) {
    return <AditionalPhoto onClose={() => setIsCameraOpen(false)} />
  }

  const resetReviewPhoto = () =>
    setShowReviewPhoto({
      uri: '',
      action() {},
      show: false,
    })

  return (
    <>
      <>
        <TemplatePage styleContent={{ padding: 0, marginBottom: 0 }} header title='Resumen'>
          <KeyboardAvoidingView
            style={[globalStyle.viewContainer, { padding: 0 }]}
            behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
          >
            <ScrollView ref={scrollViewRef}>
              <FormHeader title={t('Resumen')} customStyle={{ padding: 16 }} hasBg hasCaseNumber />

              {externalPhoto.uri !== null && (
                <PhotoCard
                  title={t('Foto externa general')}
                  time={externalPhoto.dateTime?.time!}
                  uri={externalPhoto.uri}
                  onPress={() =>
                    setShowReviewPhoto({
                      show: true,
                      uri: externalPhoto.uri!,
                      action: () => navigation.replace('ExternalPhoto', { returnToSummary: true }),
                    })
                  }
                />
              )}
              <Separator />
              {gillPhoto.uri && (
                <PhotoCard
                  hasBg
                  title={t('Foto interna branquias')}
                  time={gillPhoto.dateTime?.time!}
                  uri={gillPhoto.uri}
                  onPress={() =>
                    setShowReviewPhoto({
                      show: true,
                      uri: gillPhoto.uri!,
                      action: () => navigation.replace('GillPhoto', { returnToSummary: true }),
                    })
                  }
                />
              )}
              {internalPhoto.uri !== null && (
                <PhotoCard
                  title={t('Foto interna general')}
                  time={internalPhoto.dateTime?.time!}
                  uri={internalPhoto.uri}
                  onPress={() =>
                    setShowReviewPhoto({
                      show: true,
                      uri: internalPhoto.uri!,
                      action: () => navigation.replace('InternalPhoto', { returnToSummary: true }),
                    })
                  }
                />
              )}
              <Separator />

              <Separator />
              {Object.values(additionalPhotos).length > 0 && (
                <>
                  {Object.entries(additionalPhotos).map(([key, photo], index) => (
                    <PhotoCard
                      key={photo.uri}
                      title={t('Foto adicional')}
                      time={photo.dateTime?.time!}
                      uri={photo.uri!}
                      hasBg={index % 2 === 0}
                      hasDelete={{
                        onDelete() {
                          removeAditionalPhoto(key)
                        },
                      }}
                    />
                  ))}
                </>
              )}

              <Separator />
              <Comments
                onChange={(value) => {
                  if (value.length >= 199) {
                    setmaxLengthText({ show: true })
                  } else {
                    onChangeValues({ name: 'comments', value })
                  }
                }}
                values={values.comments}
              />
              <ActionsButtons onAddPhoto={() => setIsCameraOpen(true)} onSave={handleSaveData} />
            </ScrollView>
          </KeyboardAvoidingView>
        </TemplatePage>
      </>

      {showReviewPhoto.show && (
        <AlertMessage
          title=''
          action={() => {
            showReviewPhoto.action()
            resetReviewPhoto()
          }}
          successLabel={t('Repetir')}
          cancelLabel={t('Salir')}
          cancelButton
          actionCancelButton={resetReviewPhoto}
        >
          <Image
            source={{ uri: showReviewPhoto.uri }}
            style={{ width: '100%', height: 500, borderRadius: 10 }}
            resizeMode='cover'
          />
        </AlertMessage>
      )}

      {maxLengthText.show && (
        <AlertMessage
          title='Error'
          successLabel={t('Aceptar')}
          cancelButton
          actionCancelButton={() => {
            setmaxLengthText({ show: false })
          }}
        >
          <Text style={{ textAlign: 'center', fontSize: 18, color: textColor }}>
            {t(' Escriba un maximo de 200 caracteres')}
          </Text>
        </AlertMessage>
      )}
    </>
  )
}
